import get from 'lodash/get'
import { Dispatch } from 'redux'
import { getCredits, applyCredits } from 'util/server/credits'

type SetCreditDispatcher = Dispatch<{
  type: 'SET_CREDITS'
  data: { default: number }
}>

export function fetchCredits() {
  return async (dispatch: SetCreditDispatcher) => {
    const creditBalance = await getCredits()
    dispatch({ type: 'SET_CREDITS', data: { default: creditBalance } })
  }
}

export function applyPromoCode(code: string) {
  return (dispatch: SetCreditDispatcher) => {
    if (!code) {
      return Promise.reject({ messageKey: 'dweb_flash_enter_valid_promo_code', type: 'error' })
    }

    return applyCredits(code)
      .then((creditsRemaining) => {
        dispatch({ type: 'SET_CREDITS', data: { default: Number(creditsRemaining) } })
        const flash = { type: 'success', messageKey: 'dweb_flash_promotion_successfully_redeemed' }
        return Promise.resolve(flash)
      })
      .catch((err) => {
        const errors = get(err, 'response.data.errors')
        const flash: { message?: string; messageKey?: string; type: string } = {
          messageKey: 'dweb_flash_promo_code_not_validated',
          type: 'error',
        }

        if (Array.isArray(errors)) {
          const message = get(err, 'response.data.errors[0].message')

          if (message === 'Promocode is invalid') {
            flash.messageKey = 'dweb_flash_enter_valid_promo_code'
          } else {
            delete flash.messageKey
            flash.message = message
            flash.type = 'alert'
          }
        }

        return Promise.reject(flash)
      })
  }
}
